import app from 'firebase/app';
import React from 'react';

const AuthUserContext = React.createContext<null | app.User>(null);

export default AuthUserContext;
